import { Col, Row } from 'reactstrap'
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown'
import Heading from '../../../../components/heading/Heading'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import styles from './PayerInformation.styles'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import { HEADING } from '../../../../components/heading/constants/constants'
import { componentKey, setActivateConfirmationModalOpen, setDeActivateConfirmationModalOpen, setDeleteConfirmationModalOpen, setGenerateReportDrawer, setHighlightedPayer, setPayersList, setShowAssignToUserTable } from '../PayerListSlice'
import { useDispatch, useSelector } from 'react-redux'
import Payer from '../../../../../libs/utility/Payer'
import VerticalSeparator from "../../../../components/separator/verticalseparator/VerticalSeparator"
import ActivityPieChart from '../activitypiechart/ActivityPieChart'
import HeaderWNotification from '../headerwnotification/HeaderWNotification'
import { formStatusLabels, recipientStatusLabels, statusColors } from './constants'
import { componentKey as authenticationComponentKey } from '../../../authentication/AuthenticationSlice'
import { TxSpinner } from '../../../../components/spinner/TxSpinner'
import { setSelectedPayer } from '../../PayerSectionSlice'
import { PAYER_SECTION_ROUTES } from '../../constants'
import { PAGE_PERMISSIONS } from '../../../dashboard/constants/constant'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'
import useFormatTIN from '../../../../../libs/customhooks/useFormatTIN'
import { RECIPIENT_SECTION_ROUTES } from '../../../recipientssection/constants'
import { QUERY_PARAMS } from '../../../formssection/constants'

export default function PayerInformation() {

    const navigate = useTxNavigate();

    const dispatch = useDispatch();
    const { formatTIN } = useFormatTIN() 

    const { highlightedPayer, formsStatus, recipientsStatus, selectedPayers, pieChartLoader, showGenerateReportDrawer, payersList } = useSelector((state) => state[componentKey]);
    const { signedInUser } = useSelector(state => state[authenticationComponentKey])

    const { FirstName = "", LastName, IdType, IdNumber, Email, ClientPayerId, Address1, Address2, City, Country,
        ZipCode, DisregardedEntity, PhoneNumber, hideTIN, IsActive } = highlightedPayer;
        
    const handleHideTinForHighlightedPayer = (thisPayer, currentAction) => {
        const updatedPayersList = payersList.map(payer => {
            if (payer.PayerDetailId === thisPayer.PayerDetailId) {
                return {
                    ...payer,
                    hideTIN: currentAction,
                }
            } else {
                return payer
            }
        })
        dispatch(setPayersList(updatedPayersList));
        const hideTIN = currentAction;
        const updatedHighlightedPayer = { ...thisPayer, hideTIN }
        dispatch(setHighlightedPayer(updatedHighlightedPayer));
    };

    const CREATE_NEW_DROPDOWN_ITEMS = [
        { itemName: "Generate Report", onClick: () => dispatch(setGenerateReportDrawer(!showGenerateReportDrawer)) },
        { itemName: IsActive ? "Deactivate" : "Activate", onClick: () => IsActive ? dispatch(setDeActivateConfirmationModalOpen(true)) : dispatch(setActivateConfirmationModalOpen(true)), permissions: PAGE_PERMISSIONS.EDIT_PAYERS },
        { itemName: `${hideTIN == false ? 'Hide' : 'Show'} TIN`, onClick: () => handleHideTinForHighlightedPayer(highlightedPayer, hideTIN == false ? true : false) },
        {
            itemName: `Edit`, onClick: () => {
                dispatch(setSelectedPayer(highlightedPayer));
                navigate(`/${PAYER_SECTION_ROUTES.PAYER}/${PAYER_SECTION_ROUTES.EDIT}`)
            },
            permissions: PAGE_PERMISSIONS.EDIT_PAYERS
        },
        { itemName: "Delete", onClick: () => dispatch(setDeleteConfirmationModalOpen(true)), permissions: PAGE_PERMISSIONS.DELETE_PAYERS },
    ];

    const ASSIGN_TO_USER_ITEM = {
        itemName: "Assign to User", onClick: () => dispatch(setShowAssignToUserTable(true))
    }

    // Show the Assign to User option to Enterprise users only
    if (signedInUser?.UserType == 3) {
        CREATE_NEW_DROPDOWN_ITEMS.unshift(ASSIGN_TO_USER_ITEM)
    }

    const notifications = [
        {
            count: formsStatus.ResubmitCount,
            message: "forms got rejected",
            action: "Review forms"
        },
        {
            count: recipientsStatus.TinNotRequestedCount,
            message: "Unverified recipients found! Please ensure to verify the Taxpayer Identification Number (TIN) with the IRS to avoid any errors in e-filing.",
            action: "Kindly verify the TIN with the IRS",
            link: `/${RECIPIENT_SECTION_ROUTES.RECIPIENT}?${QUERY_PARAMS.PAYER_ID}=${highlightedPayer?.PayerDetailId}`,
        },
    ]

    const { ProcessingCount = 0, ResubmitCount = 0, PendingCount = 0, AcceptedCount = 0 } = formsStatus;
    const formStatusSeries = [+ProcessingCount, +ResubmitCount, +PendingCount, +AcceptedCount];

    const { TinNotRequestedCount = 0, W8W9Count = 0, TINRequestedCount = 0, TotalCount = 0 } = recipientsStatus;
    const recipientStatusSeries = [+TinNotRequestedCount, +W8W9Count, +TINRequestedCount, +TotalCount];

    return (
        <>
            <div style={styles.header}>

                <div style={styles.payerNameContainer}>
                    <Icons familyName='vec' iconName={VEC_ICON_NAME.USER_ICON} />
                    <div>
                        <Heading type={HEADING.H2} >{`${FirstName} ${LastName || "N/A"}`}</Heading>
                        <span>{formatTIN(IdType, IdNumber, hideTIN ?? true) || "N/A"}</span>
                    </div>
                </div>
                <div>
                    <IconDropdown
                        label="Action"
                        dropdownItems={CREATE_NEW_DROPDOWN_ITEMS}
                        dropdownContainerStyles={styles.actionDropdown}
                        styles={styles.actionDropdownLabel}
                        dropdownMenuStyle={styles.actionDropdownMenu}
                    />
                </div>
            </div>

            <div style={styles.detailsContainer}>

                <Row style={styles.gapBetween}>
                    <Col lg={5} >
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.EMAIL_GREY_ICON} />
                        <span style={styles.detailsLabel}>{Email || "N/A"}</span>
                    </Col>
                    <Col lg={5}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.PHONE_ICON} />
                        <span style={styles.detailsLabel}>{PhoneNumber || "N/A"}</span>
                    </Col>
                </Row>
                <Row style={styles.gapBetween}>
                    <Col lg={5}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.BUISNESS_ICON} />
                        <span style={styles.detailsLabel}>Disregarded Entity - {DisregardedEntity || "N/A"}</span>
                    </Col>
                    <Col lg={5}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.CLIENT_ICON} />
                        <span style={styles.detailsLabel}>Client ID - {ClientPayerId || "N/A"}</span>
                    </Col>
                </Row>
                <Row style={styles.gapBetween}>
                    <Col>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.HOME_ICON} />
                        <span style={styles.detailsLabel}>{`${Address1 || "N/A"}, ${Address2 ? Address2 + "," : ""} ${City || "N/A"}, ${ZipCode || "N/A"}, ${Country || "N/A"}`}</span>
                    </Col>
                </Row>
            </div>

            {pieChartLoader ?
                <TxSpinner />
                :
                <>
                    <div style={styles.importantNotificationsContainer}>
                        {(formsStatus.ResubmitCount || recipientsStatus.TinNotRequestedCount) ?
                            <HeaderWNotification
                                iconName={VEC_ICON_NAME.ALERT_ICON}
                                heading='Important notifications'
                                description='These are a few issues that needs your attention'
                                notifications={notifications}
                            /> : <HeaderWNotification
                                iconName={VEC_ICON_NAME.CIRCULAR_TICK_ICON}
                                heading='All looks good!'
                                description='Everything looks fine with this payer. You can view insights related to this payer below.'
                            />
                        }
                    </div>

                    <HorizontalSeparator style={styles.horizontalLine} />

                    <HeaderWNotification
                        heading='Activities from the year 2023'
                        headerType={HEADING.H2}
                        description="These are the overall activities of this payer for the whole year"
                    />

                    <div style={styles.chartContainer}>

                        <ActivityPieChart
                            labels={formStatusLabels}
                            colors={statusColors}
                            series={formStatusSeries}
                            totalLabel="Forms"
                        />

                        <VerticalSeparator style={{ height: "inherite" }} />

                        <ActivityPieChart
                            labels={recipientStatusLabels}
                            colors={statusColors}
                            series={recipientStatusSeries}
                            totalLabel="Recipients"
                        />

                    </div>
                </>
            }

            <HorizontalSeparator style={styles.horizontalLine} />
        </>
    )

}